module.exports = __webpack_public_path__ + "static/Filterbag-956ae1d20a3a0f3389dd8bdc18154169.jpg";